import React from "react";
import PropTypes from "prop-types";
import ReactDataGrid from "react-data-grid";
import styles from "components/settings/billing-history.scss";
import { PaginationBar } from "components/common/pagination-bar";
import { DateCellFormatter } from "components/grid/cell-formatters/date-cell-formatter";
import { TotalCellFormatter } from "components/grid/cell-formatters/total-cell-formatter";
import { InvoiceActionsFormatter } from "components/settings/invoice-actions-formatter";
import { NoHistoricalInvoices } from "components/settings/no-historical-invoices";
import { invoiceType, paginationType } from "custom-prop-types";

export const BillingHistory = (props) => {
  if (props.displayInvoices.length === 0) {
    return <NoHistoricalInvoices />;
  }
  return (
    <div>
      <h1>Billing History</h1>
      <div className={ styles["grid-container"] }>
        <ReactDataGrid
          columns={ columns }
          enableCellSelect={ false }
          minHeight={ props.displayInvoices.length * 35 }
          rowGetter={ getRow(props.displayInvoices) }
          rowHeight={ 35 }
          rowsCount={ props.displayInvoices.length }
        />
        <PaginationBar
          { ... props }
          limit={ props.pagination.limit }
          pageNumber={ props.pagination.pageNumber }
          totalResults={ props.invoices.length }
        />
      </div>
    </div>
  );
};

BillingHistory.defaultProps = {
  displayInvoices: []
};

BillingHistory.propTypes = {
  displayInvoices: PropTypes.arrayOf(invoiceType),
  invoices: PropTypes.arrayOf(invoiceType).isRequired,
  pagination: paginationType.isRequired
};

const columns = [
  {
    formatter: DateCellFormatter,
    key: "createdAt",
    name: "Date"
  },
  {
    key: "invoiceNumber",
    name: "Invoice Number"
  },
  {
    formatter: TotalCellFormatter,
    key: "total",
    name: "Amount"
  },
  {
    formatter: InvoiceActionsFormatter,
    key: "pdfUrl",
    name: "Download",
    getRowMetaData: (row) => row
  }
];

const getRow = (invoices) => (index) => invoices[index];



// WEBPACK FOOTER //
// ./src/js/components/settings/billing-history.jsx